import {
  useQueryStates,
  parseAsArrayOf,
  parseAsInteger,
  parseAsStringLiteral,
} from 'nuqs'
import { FIELDGLASS_ISSUE_TYPE_VALUES } from 'pages/Fieldglass/shared/constants/issueTypes'

const _DEFAULT_DAYS_AGO = 14

export const useFieldglassShiftIssuesFiltersQueryState = () => {
  return useQueryStates(
    {
      companyGroupIds: parseAsArrayOf(parseAsInteger),
      issueTypes: parseAsArrayOf(
        parseAsStringLiteral(FIELDGLASS_ISSUE_TYPE_VALUES)
      ),
      daysAgo: parseAsInteger.withDefault(_DEFAULT_DAYS_AGO),
    },
    {
      urlKeys: {
        companyGroupIds: 'company-group-ids',
        issueTypes: 'issue-types',
        daysAgo: 'days-ago',
      },
    }
  )
}
